import { render } from "./AddFileResponse.vue?vue&type=template&id=715e7cf7&scoped=true"
import script from "./AddFileResponse.vue?vue&type=script&lang=js"
export * from "./AddFileResponse.vue?vue&type=script&lang=js"

import "./AddFileResponse.vue?vue&type=style&index=0&id=715e7cf7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715e7cf7"]])

export default __exports__